<template>

    

    <div class="fav-container">
        <div class="fav-title">
            {{ $t('EDIT_FAVOURITE') }}
        </div>

        <Sticky
            :top="48"
            :show="48"
            v-if="isMobile"
            stickyClass="scroll_top_fav-nav"
            :stickyShowBefore="true">
            <div class="fav-tabs 1 scroll_top_fav-nav">
                <div class="fav-tab" 
                    v-for="(item,index) in tabs"
                    @click="selectTab(item)"
                    :class="{
                        'selected': item.selected
                    }"
                    :key="index">
                    {{ $t(item.name) }}
                </div>
            </div>
        </Sticky>
        <div class="scrollTop48"></div>
        <div class="fav-tabs 2" v-if="!isMobile">
            <div class="fav-tab" 
                v-for="(item,index) in tabs"
                @click="selectTab(item)"
                :class="{
                    'selected': item.selected
                }"
                :key="index">
                {{ $t(item.name) }}
            </div>
        </div>


        <div v-show="isMobile && $route.name !== 'footballFavMatches'">
            <Suggestions 
                v-model:selectedTab="selectedTab"
                ref="refSuggestions"
                @favTeamSuccess="favTeamSuccess" />
        </div>
        <div v-show="!isMobile">
            <Suggestions 
                v-model:selectedTab="selectedTab"
                ref="refSuggestions"
                @favTeamSuccess="favTeamSuccess" />
        </div>
        
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex' 
    import Suggestions from './components/Suggestions.vue';
    export default {
        name: 'FavSidebar',
        data() {
            return {
                selectedTab: 'COMPETITIONS',
                selectedTabPathName: 'footballFavCompetitions',
                tabs: [
                    {
                        name: 'COMPETITIONS',
                        selected: false,
                        pathName: "footballFavCompetitions"
                    },
                    {
                        name: 'TEAMS',
                        selected: false,
                        pathName: "footballFavTeams"
                    },
                    {
                        name: 'PLAYERS',
                        selected: false,
                        pathName: "footballFavPlayers"
                    }
                ],
                tabsWebapp: [
                    {
                        name: 'MATCHES',
                        selected: false,
                        pathName: "footballFavMatches"
                    },
                    {
                        name: 'COMPETITIONS',
                        selected: false,
                        pathName: "footballFavCompetitions"
                    },
                    {
                        name: 'TEAMS',
                        selected: false,
                        pathName: "footballFavTeams"
                    },
                    {
                        name: 'PLAYERS',
                        selected: false,
                        pathName: "footballFavPlayers"
                    }
                ]
            }
        },
        components: {
            Suggestions
        },
        computed: {
            ...mapState(['scrollTop']),
            ...mapGetters([
                'userInfo',
                'isLogin',
                "isMobile",
                "currentSportType",
            ]),
        },
        mounted() {
            this.initTab()
        },
        watch: {
            isMobile() {
                this.initTab()
            },
            '$route.name'(newVal) {
                let pathList = [
                    'footballFavCompetitions',
                    'footballFavTeams',
                    'footballFavPlayers',
                    'footballFavMatches',
                ]
                if(pathList.includes(newVal) && this.selectedTabPathName !== newVal) {
                    this.initTab()
                }
            }
        },
        methods: {
            
            initTab() {
                let tabs = JSON.parse(JSON.stringify(this.tabsWebapp))
                if(!this.isMobile) {
                    tabs.splice(0, 1);
                }
                for(var i in tabs) {
                    tabs[i].selected = false
                }
                tabs[0].selected = true
                this.tabs = tabs
                let selected = false;
                this.tabs.forEach(x => {
                    if(x.pathName === this.$route.name) {
                        x.selected = true
                        this.selectedTab = x.name
                        selected = true
                    } else {
                        x.selected = false
                    }
                })  
                if(!selected) {
                    if(this.isMobile) {
                        setTimeout(() => {
                            this.$router.push({
                                name: this.tabs[0].pathName
                            })
                        }, 100)
                    }
                    this.selectTab(this.tabs[0])
                }
            
                if(!this.isMobile && this.$route.name !== 'footballFavMatches') {
                    setTimeout(() => {
                        this.$router.replace({
                            name: 'footballFavMatches'
                        })
                    }, 100)
                }
            },

           
            selectTab(item) {

                this.tabs.forEach(x => {
                    x.selected = false
                })

                item.selected = true
                this.selectedTab = item.name
                this.selectedTabPathName = item.pathName
                this.$refs.refSuggestions.init(this.selectedTab)
                if(this.isMobile) {
                    this.$router.replace({
                        name: item.pathName
                    })
                }
                
            },
            favTeamSuccess() {
                this.$emit('favTeamSuccess')
            },
            updateToTeamTab() {
                let selectTab = this.isMobile ? 2 : 1 
                this.selectTab(this.tabs[selectTab])
            }
        },
    }
</script>

<style scoped>
.fav-container {
    width: 380px;
    padding: 16px;
    background-color: var(--color-background-default-secondary);
    border-radius: 16px;
}
.fav-title {
    font-size: 20px;
    color: var(--color-text-default-default);
    margin-bottom: 16px;
}
.fav-tabs {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}
.fav-tab {
    flex: 1;
    padding: 16px;
    text-align: center;
    color: var(--color-text-default-secondary);
    position: relative;
    font-family: var(--weight-600);
    cursor: pointer;
    letter-spacing: 0.64px;
}
.fav-tab.selected {
    color: var(--color-text-default-default);
}
.fav-tab.selected::after {
    content: "";
    position: absolute;
    display: block;
    bottom: 0;
    left: 10%;
    width: 80%;
    height: 2px;
    background-color: var(--color-background-brand-default);
    border-radius: 4px;
}

@media(max-width: 768px) {  /* for test */
.fav-container {
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    border-radius: 0;
    background-color: transparent;
}
.fav-tabs {
    justify-content: center;
    margin-bottom: 0;
    background-color: var(--color-background-default-secondary);
}
.fav-tab {
    font-size: 13px;
    padding: 16px 8px;
    flex: unset;
}
.fav-title {
    display: none;
}
/* .mobile-tabs {
    display: flex;
    align-items: center;
    justify-content: center;
}
.mobile-tab {
    padding: 16px 8px;
    box-sizing: border-box;
    color: var(--color-text-default-tertiary);
    border-bottom: 2px solid transparent;
    font-family: var(--weight-700);

}
.mobile-tab.selected {
    color: var(--color-text-default-default);
    border-bottom: 2px solid var(--color-background-brand-default);
} */
.scrollTop48 {
    height: 48px;
}
}
</style>

<style>
.scroll_top_fav-nav {
    top: 48px;
    position: fixed;
    border-bottom: 1px solid var(--color-border-default-default);
    width: 100%;
    background: var(--color-background-default-secondary);
    left: 0;
  }
</style>